import { ExternalLink } from "lucide-react";
import Reveal, { Overline } from "./Reveal";

const MILESTONES = [
  {
    title: "KD Pendekar — Navy Warship",
    desc: "Refloated the Royal Malaysian Navy's 45-year-old KD Pendekar from the seabed two nautical miles off Tanjung Penyusop, Johor — a defining precision salvage completed despite extreme conditions.",
    link: {
      source: "Astro Awani",
      url: "https://www.astroawani.com/berita-malaysia/kd-pendekar-berjaya-diapung-semula-tldm-491616",
    },
  },
  {
    title: "PETRONAS High & Heavy Lift",
    desc: "Major high and heavy lifting project completed for PETRONAS — a true giant of oil & gas.",
  },
];

export default function Salvage() {
  return (
    <section
      id="salvage"
      data-testid="salvage"
      className="relative overflow-hidden py-28 lg:py-40"
    >
      <div className="absolute inset-0">
        <img
          src="images/deck-cranes.jpg"
          alt="Marine heavy lifting at dusk"
          className="h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-ink/55" />
        <div className="absolute inset-0 bg-gradient-to-b from-ink/90 via-transparent to-ink/90" />
      </div>

      <div className="relative z-10 mx-auto max-w-[1400px] px-6 lg:px-12">
        <Reveal>
          <Overline>Flagship Division</Overline>
          <h2 className="mt-6 max-w-4xl font-display text-5xl font-medium uppercase leading-[0.92] tracking-tighter sm:text-6xl lg:text-7xl">
            We raise what
            <br />
            <span className="font-serif italic font-medium tracking-normal text-brand">
              the sea sinks.
            </span>
          </h2>
        </Reveal>

        <div className="mt-12 grid gap-10 lg:grid-cols-12">
          <Reveal delay={0.1} className="lg:col-span-5">
            <p className="max-w-md text-base font-light leading-relaxed text-slate-200 sm:text-lg">
              Udat Marine is now a leader in marine heavy lifting and shipwreck
              salvage. We have successfully recovered many sunken vessels —
              including the Royal Malaysian Navy's KD Pendekar, refloated off
              Tanjung Penyusop — and completed a major heavy lift for PETRONAS.
              This is the future of our company, built on a proven track record.
            </p>
            <p className="mt-5 max-w-md font-mono text-[10px] uppercase leading-loose tracking-[0.2em] text-steel">
              Wreck removal · Refloating · Emergency towing · Underwater hull surveys
            </p>
          </Reveal>

          <Reveal delay={0.2} className="lg:col-span-7">
            <div className="grid gap-4 sm:grid-cols-2">
              {MILESTONES.map((m) => (
                <div
                  key={m.title}
                  data-testid="salvage-milestone-card"
                  className="flex flex-col border border-line bg-ink/70 p-7 backdrop-blur-sm transition-colors duration-300 hover:border-brand"
                >
                  <div className="font-mono text-[10px] uppercase tracking-[0.22em] text-brand">
                    Milestone
                  </div>
                  <h3 className="mt-4 font-display text-xl uppercase tracking-tight text-white sm:text-2xl">
                    {m.title}
                  </h3>
                  <p className="mt-3 flex-1 text-sm font-light leading-relaxed text-steel">
                    {m.desc}
                  </p>
                  {m.link && (
                    <a
                      data-testid="salvage-news-link"
                      href={m.link.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="mt-5 inline-flex w-fit items-center gap-2 border border-brand px-4 py-2.5 font-mono text-[9px] uppercase tracking-[0.18em] text-brand transition-colors duration-300 hover:bg-brand hover:text-white"
                    >
                      <ExternalLink size={12} />
                      As featured on {m.link.source} — read the story
                    </a>
                  )}
                </div>
              ))}
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
